import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import PrivateNote from "./PrivateNote";
import ModalTViewAnswer from "./Modal/ModalTViewAnswer";
import { useDispatch, useSelector } from "react-redux";
import { GetListAnswerAssessee } from "../../actions/answerAssesseeActions";

const dataShow = [
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
];

export default function AnswerListFromAssessee() {
  const [showNum, setShowNum] = useState(1);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const toggleShow = (n) => {
    setShowNum(n);
  };
  const [dataInModal, setDataInModal] = useState({
    name: "",
    email: "",
  });
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const storeGet = useSelector((state) => state.smvm_get_list_answer_assessee);
  useEffect(() => {
    dispatch(GetListAnswerAssessee());
  }, []);
  useEffect(() => {
    if (storeGet.success) {
      setLoading(false);
      setShowModal(false);
      setData(storeGet.data);
    }
    if (storeGet.error) {
      console.log("Set Answer Error");
      console.log("Set Answer Error", storeGet);
    }
  }, [storeGet]);
  const handleShow = (data) => {
    setDataInModal({
      name: data.name,
      email: data.email,
      text: data.submission,
    });
    setShowModal(true);
  };
  return (
    <>
      <div className="py-2 ">
        <div class="p-4 bg-white m-1">
          <div class="flex justify-between items-center  ">
            <p className="border-b w-full text-left text-sm font-bold text-gray-600">
              List Answer
            </p>
          </div>

          {data?.length > 0 ? (
            <div class="flow-root px-4 overflow-auto max-h-[85vh]" style={{}}>
              <ul role="list" class="divide-y divide-gray-200  ">
                {data?.map((x, i) => {
                  return (
                    <li class="py-2 sm:py-2 relative">
                      <div class="flex items-center space-x-4">
                        <div class="flex-shrink-0">
                          <img
                            class="w-8 h-8 rounded-full"
                            src={x.picAva}
                            alt="Neil image"
                          />
                        </div>
                        <div class="flex-1 min-w-0 text-left">
                          <p class="text-sm font-medium text-gray-900 truncate ">
                            {x.name}
                          </p>
                          <p class="text-sm text-gray-500 truncate ">
                            {x.email}
                          </p>
                        </div>
                      </div>
                      <div className="absolute right-0 top-0 h-full  flex items-center">
                        <p
                          onClick={() => {
                            handleShow(x);
                          }}
                          className={
                            "text-xs font-normal text-secondary-600 hover:underline cursor-pointer"
                          }
                        >
                          View
                        </p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : (
            <div className="flex justify-center items-center max-h-[85vh] h-[100vh]  w-full">
              <p className="text-gray-500">No data available</p>
            </div>
          )}
        </div>
        {/* <section className="max-w-6xl mx-auto text-center ">
        <Accordion
          title="Guide"
          content={lorem + "-" + lorem + "-" + lorem + "-" + lorem}
          expanded={showNum == 1}
          toggleExpanded={() => toggleShow(1)}
        />
        <Accordion
          title="Aspect"
          content={lorem}
          expanded={showNum == 2}
          toggleExpanded={() => toggleShow(2)}
        />
        <Accordion
          title="Private Note"
          content={
            <>
              <PrivateNote />{" "}
            </>
          }
          expanded={showNum == 3}
          toggleExpanded={() => toggleShow(3)}
        />
      </section> */}
      </div>
      <div>
        <ModalTViewAnswer
          name={dataInModal?.name}
          email={dataInModal?.email}
          showModal={showModal}
          setShowModal={setShowModal}
          text={dataInModal?.text}
        />
      </div>
    </>
  );
}

const lorem =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";

function Accordion({ title, content, toggleExpanded, expanded }) {
  // const [expanded, setExpanded] = useState(onShow);
  // const toggleExpanded = () => setExpanded((current) => !current);

  return (
    <div
      className="my-2 shadow-sm cursor-pointer bg-white"
      onClick={(e) => {
        e.preventDefault();
        toggleExpanded();
      }}
    >
      <div className="px-6 text-left items-center h-20 select-none flex justify-between flex-row">
        <h5 className="flex-1 ">
          <label className="font-bold leading-tight text-secondary-500 text-lg ">
            {title}
          </label>
        </h5>
        <div className="flex-none pl-2">
          {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </div>
      </div>
      <div
        className={`px-6 pt-0  transition-[max-height] duration-500 ease-in ${
          expanded ? "max-h-[60vh] overflow-auto " : "max-h-0 overflow-hidden "
        }`}
      >
        <div className="pb-4 text-left min-h-[60vh] ">{content}</div>
      </div>
    </div>
  );
}
